<script>
  import BlinkingCursor from './BlinkingCursor.svelte'; // Adjust the path as needed

  export let message = "";

  let lines;
  $: lines = message.split('\n'); // Reactive statement

  function trimPipe(line) {
    return line.endsWith('|') ? line.slice(0, -1) : line;
  }
</script>

{#if message.endsWith('|')}
  {#each lines as line, index}
    {trimPipe(line)}
    {#if index < lines.length - 1}
      {#if index > 0 }
        <br>
       {/if}
    {:else}
      <BlinkingCursor />
    {/if}
  {/each}
{:else}
  {#each lines as line, index}
    {line}
    {#if index > 0 && index < lines.length - 1}
      <br>
    {/if}
  {/each}
{/if}


<!--
{#if message.endsWith('|')}
  {message.slice(0, -1)} <BlinkingCursor />
{:else}
  {message}
{/if}
-->
